import { useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import NewOrganizationRole from "./NewOrganizationRole";
import { useGetOrganizationRole } from "../../../../../services/organization-role.service";
import { OrganizationRoleDto } from "../../../../../models/organization-role.dto";
import { useGetPermission } from "../../../../../services/permission.service";
import EditOrganizationRole from "./EditOrganizationRole";
import useUserStore from "../../../../../state-management/useUserStore";
import { SkewLoader } from "react-spinners";
import { APP_CONFIG } from "../../../../../helpers/appHelpers";
import { PermissionOrderBy } from "../../../../../models/permission.dto";
import CustomPagination from "../../../../../components/table/CustomPagination";
import { PermissionChecker, PERMISSIONS, useCheckUserPermissions } from "../../../../../helpers/usePermissionManager";
import { useManageTableWithStateVariables } from "../../../../../helpers/useManageTable";

const Roles = () => {
	const { currentUser } = useUserStore();
	const { checkUserPermissionsAnd } = useCheckUserPermissions();
	const [showNewRolesForm, setShowNewRolesForm] = useState(false);
	
	const {
		tableData: organizationRoles,
		isLoading,
		page,
		pageCount,
		addNewData,
		reloadData,
		handlePageChange,
	} = useManageTableWithStateVariables<OrganizationRoleDto>({ 
		fetchHook: useGetOrganizationRole,
		options: {
			organizationId: currentUser.user.organizationId,
			limit: 8,
		}
	});

	const { data: permissionsData } = useGetPermission({
		limit: APP_CONFIG.PAGE_LIMIT,
		orderBy: PermissionOrderBy.NAME_ASC,
	});
	
	return (
		<>
			<div className="border-b-[1.5px] pb-3 mb-4 flex w-full justify-between text-sm">
				<h2 className="font-semibold">User Role Management</h2>
				<PermissionChecker permissions={[PERMISSIONS.ORGANIZATION_ROLES_WRITE]}>
					<button
						onClick={() => setShowNewRolesForm(true)}
						className={`border-none flex items-center text-primary-blue`}
					>
						<AiOutlinePlus className="mr-2 text-lg" />
						Add New Role
					</button>
				</PermissionChecker>
			</div>

			{showNewRolesForm && (
				<NewOrganizationRole 
					open={showNewRolesForm} 
					setOpen={setShowNewRolesForm} 
					permissionsData={permissionsData}
					addNewData={addNewData}
				/>
			)}
			
			{(isLoading && !organizationRoles.length && checkUserPermissionsAnd([PERMISSIONS.ORGANIZATION_ROLES_READ])) && (
				<div className="text-center mt-10 py-10">
					<SkewLoader color="#F58B00" />
				</div>
			)}
		
			{organizationRoles.map((organizationRole: OrganizationRoleDto) => (
				<EditOrganizationRole 
					key={organizationRole.id}
					permissionsData={permissionsData}
					organizationRole={organizationRole}
					reloadData={reloadData}
				/>
			))}

			{(!isLoading && !organizationRoles.length && checkUserPermissionsAnd([PERMISSIONS.ORGANIZATION_ROLES_READ])) && (
				<div>
					<h3 className="text-center text-sm font-semibold mt-10">
						Sorry no roles added yet. Click 'Add New Role' to begin.
					</h3>
				</div>
			)}

			{checkUserPermissionsAnd([PERMISSIONS.ORGANIZATION_ROLES_READ]) ? (
				<div className="w-full flex justify-end my-8">
					<CustomPagination 
						pageCount={pageCount} 
						pageState={page}
						handleChange={handlePageChange}
					/>
				</div>
			):(
				<div>
					<h3 className="text-center text-sm font-semibold mt-10">
						You are not authorized to access this data.
					</h3>
				</div>
			)}
		</>
	);
};

export default Roles;
